import {getMethod, patchMethod, postMethod, putMethod} from '~/api'

async function get(hotelId, request) {
    return await getMethod(`/api/ownHotelInfo/${hotelId}`, request)
}

async function post(request) {
    return await postMethod('/api/ownHotelInfo', request)
}

async function put(hotelId, request) {
    return await putMethod(`/api/ownHotelInfo/${hotelId}`, request)
}

async function patch(id, request) {
    return await patchMethod(`/api/ownHotelInfo/${id}`, request)
}

export {get, post, put, patch}
